import { ErrorBoundary } from 'react-error-boundary'
import { ReactNode } from 'react'
import { ErrorFallback } from '@shared/ui'

export const ErrorProvider = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    {children}
  </ErrorBoundary>
)
